import { RetailRocketService } from '@analytics/feature';
import { Injectable } from '@angular/core';
import { CityActions } from '@city/data-access';
import { CityService } from '@city/feature';
import { CustomRouterStateSnapshot } from '@core/const';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION, RouterNavigationAction } from '@ngrx/router-store';
import { RRList } from '@reference/const';
import { ProductReferenceApiService, ReferenceActions } from '@reference/data-access';
import { ProductActions } from '@spartacus/core';
import { catchError, combineLatest, from, Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, mergeMap, switchMap, take } from 'rxjs/operators';

@Injectable()
export class RetailRocketEffects {
  loadRecomendation$: Observable<
    ReferenceActions.LoadRetailRocketRecomendationListSuccess | ReferenceActions.LoadRetailRocketRecomendationListFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferenceActions.LOAD_RR_RECOMENDATION_LIST),
      mergeMap((action) => {
        return combineLatest({
          baseStoreCode: this.cityService.activeBaseStoreCode$,
          sessionId: this.retailRocketService.getSessionId(),
        }).pipe(
          take(1),
          mergeMap(({ baseStoreCode, sessionId }) => {
            const { productCodes, algoritmType, id } = action;

            return this.productReferenceApiService
              .loadRetailRocketRecomendationList(productCodes, algoritmType, baseStoreCode, sessionId)
              .pipe(
                map(({ recommendations }: RRList) => {
                  return new ReferenceActions.LoadRetailRocketRecomendationListSuccess(id, recommendations);
                }),
                catchError((e: unknown) => of(new ReferenceActions.LoadRetailRocketRecomendationListFail(id, e))),
              );
          }),
        );
      }),
    ),
  );

  changeBaseStore$: Observable<
    ReferenceActions.ResetRetailRocketRecomendationAllList | ProductActions.CleanProductReferences
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map(({ payload }) => payload),
      distinctUntilChanged(),
      switchMap(() =>
        from([
          new ReferenceActions.ResetRetailRocketRecomendationAllList(),
          new ProductActions.CleanProductReferences(),
        ]),
      ),
    ),
  );

  changeRoute$: Observable<
    ReferenceActions.ResetRetailRocketRecomendationAllList | ProductActions.CleanProductReferences
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      map((action: RouterNavigationAction<CustomRouterStateSnapshot>) => action.payload.routerState.semanticRoute),
      filter((route): route is string => Boolean(route)),
      distinctUntilChanged(),
      switchMap(() =>
        from([
          new ReferenceActions.ResetRetailRocketRecomendationAllList(),
          new ProductActions.CleanProductReferences(),
        ]),
      ),
    ),
  );

  constructor(
    private productReferenceApiService: ProductReferenceApiService,
    private actions$: Actions,
    private cityService: CityService,
    private retailRocketService: RetailRocketService,
  ) {}
}
